// Libraries & Polyfills
import 'core-js/stable';
import 'regenerator-runtime/runtime';
// Stylesheet
import "./facadegenerator.scss"
// Tracking Setup
import "./_tagmanager";
import "./_tracking-setup";

// Always loaded Project Modules
import {shopUtilities} from '@global/shop-utilities/shop-utilities';

// Autmated Testing support
window.IS_AUTOMATED_TESTING = document.cookie.includes('automated_testing');

window.shopUtilities = shopUtilities;

document.addEventListener("DOMContentLoaded", () => {
    shopUtilities.init();
});
